
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class NumericKeypad extends Vue {
  @Prop() private status!: string; // Error, success or null
  @Prop() private disabled!: boolean;

  private number = '';

  add(num: number) {
    if (this.number.length <= 9) {
      this.number += num;
      this.$emit('update', this.number);
    }
  }

  del() {
    this.number = this.number.slice(0, -1);
    this.$emit('update', this.number);
  }

  clear() {
    this.number = '';
    this.$emit('update', this.number);
  }

  cancel() {
    this.$emit('close');
  }

  submit() {
    if (this.disabled) {
      return false;
    }
    this.$emit('submit', this.number);
  }

  get errorStatus() {
    return this.status === 'error';
  }
}
